/**
 * Force light mode when:
 * - Admin / platform UI (dense tables, editors)
 * - Marketing site on the platform host
 * - Storefront theme switch is disabled in settings
 *
 * Uses route meta so @nuxtjs/color-mode keeps `forced` across navigations.
 */
import { isPlatformMarketingPath } from '~/utils/marketingPaths'

export default defineNuxtRouteMiddleware(async (to) => {
  const domain = await ensureShopDomainResolved()
  if (
    isPlatformMarketingPath(to.path, Boolean(domain.shop))
    || to.path.startsWith('/platform')
    || /\/admin(\/|$)/.test(to.path)
  ) {
    to.meta.colorMode = 'light'
    return
  }

  const { themeSwitchEnabled, loaded } = useSiteSettings()
  if (loaded.value && !themeSwitchEnabled.value) {
    to.meta.colorMode = 'light'
  }
})
